/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const GlobalHeaderLinks = {
    loggedInHeaderViewAzureLink: 'https://go.microsoft.com/fwlink/?linkid=2163216',
    feedbackForumLink: 'https://feedback.azure.com/d365community/forum/09041fae-0b25-ec11-b6e6-000d3a4f0858',
    requestTicketLink: 'https://ms.portal.azure.com/#blade/Microsoft_Azure_Support/HelpAndSupportBlade/newsupportrequest',

    documentationHelpLink: 'https://docs.microsoft.com/azure/cognitive-services/luis/home',
    authoringAPIsHelpLink: 'https://aka.ms/ls-ta-auth-api-ref',
    predictionAPIsHelpLink: 'https://aka.ms/ls-ta-pred-api-ref',

    classificationDocumentationHelpLink: 'https://aka.ms/ctc-docs',
    extractionDocumentationHelpLink: 'https://aka.ms/ct-docs',
    customTextAuthoringAPIsLink: 'https://aka.ms/ct-authoring-swagger',
    customTextPredictionAPIsLink: 'https://aka.ms/ct-runtime-swagger',
    stackOverflowLink: 'https://stackoverflow.com/questions/tagged/luis',
    pricingLink: 'https://azure.microsoft.com/pricing/details/cognitive-services/language-understanding-intelligent-services/',
    azureSupportLink: 'https://aka.ms/studio-azuresupportplans',
    azureBlogLink: 'https://aka.ms/unifiedLanguageTechBlog',
    privacyAndTermsLink: 'https://aka.ms/studio-privacyterms',
    termsOfUserLink: 'https://aka.ms/aistudio/terms',
    trademarksLink: 'https://aka.ms/studio-legal-trademarks',
    developerCodeOfConductLink: 'https://aka.ms/studio-microsoftCodeofCoduct',

    learnMoreAboutLUISRBACLink: 'https://aka.ms/LUIS-RBAC',
    learnMoreAboutStdioRBACLink: 'https://aka.ms/language-rbac',
    viewAccountLink: 'https://myaccount.microsoft.com/?ref=MeControl',

    cognitiveServicesLink: 'https://azure.microsoft.com/services/cognitive-services/',
    loggedOutForumLink: 'https://feedback.azure.com/forums/932041-azure-cognitive-services',
    microsoftAzureBlogLink: 'https://azure.microsoft.com/blog/',
    microsoftAzureLink: 'https://azure.microsoft.com/'
};
